/**
 * Stack routes of the native screens added by the `warehouse` admin-module group.
 * Registered by AppNavigator in the management stack.
 */
import lazyScreen from '../../components/lazyScreen';

const ROUTES = [
    {name: 'WarehouseListScreen', component: lazyScreen(() => import('../../screens/adminModules/warehouse/WarehouseListScreen'))},
    {name: 'StockTransferScreen', component: lazyScreen(() => import('../../screens/adminModules/warehouse/StockTransferScreen'))},
    {name: 'StockProductionScreen', component: lazyScreen(() => import('../../screens/adminModules/warehouse/StockProductionScreen'))},
    {name: 'PartnerLogisticsSummaryScreen', component: lazyScreen(() => import('../../screens/adminModules/warehouse/PartnerLogisticsSummaryScreen'))},
    {name: 'ManufactureProcessCreateScreen', component: lazyScreen(() => import('../../screens/adminModules/warehouse/ManufactureProcessCreateScreen'))},
    // Generic settings form (route param `kind`, see settingsFormConfigs.js).
    {name: 'WarehouseSettingsFormScreen', component: lazyScreen(() => import('../../screens/adminModules/warehouse/SettingsFormScreen'))},
];

export default ROUTES;
